import Routes from "./routes/Routes";
import "./assets/css/app.css";
import "react-toastify/dist/ReactToastify.css";
import "react-tooltip/dist/react-tooltip.css";
import { ToastContainer } from "react-toastify";
import "./assets/css/Index.css";
import "react-datepicker/dist/react-datepicker.css";
import { Tooltip } from "react-tooltip";

const App = () => {
    return (
        <>
            <ToastContainer />
            <Routes />
            <Tooltip
                id="feed-message-tooltip"
                place="top"
                positionStrategy="fixed"
                style={{ zIndex: 9999, maxWidth: "32rem", whiteSpace: "normal", wordBreak: "break-word" }}
            />
        </>
    );
};

export default App;
